import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";

// Components
import Toast from "components/WMS/Toast";

// Assets
import ValidatedIcon from "assets/img/validated.svg";

// Utils
import {UserAgentUtils} from "utils/useragent";

SuccessToast.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.string,
};

function SuccessToast({isOpen, handleClose, title, subtitle = null, ...props}) {
    const icon = (
        <img
            src={ValidatedIcon}
            alt={title}
            style={{width: '20px', height: '20px'}}
        />
    );

    return (
        <Toast
            open={isOpen}
            handleClose={handleClose}
            title={title}
            subtitle={subtitle}
            isTop={!UserAgentUtils.isMobile()}
            isDesktop={!UserAgentUtils.isMobile()}
            icon={icon}
        />
    );
}

export default injectIntl(SuccessToast);
